import React from 'react';

const Jumbo = () =>
(
    <div className="jumbotron">
      <div className="container">
          <h1>Mobile Ordering Platform For Restaurants. </h1>
          <p>
              Custom Mobile App. Mobile Responsive Website. Mobile Content Management System. Integrated Menu Ordering. Real Time Customer Updates. <i>Cloud Technology For Restaurants.</i>
          </p>
          <a className="btn btn-ccta btn-lg" href="/#contact-us" role="button"> Contact Us </a>
      </div>
    </div>
);

export default Jumbo;



// WEBPACK FOOTER //
// src/components/layout/jumbotron.js